export interface RectifyDefectHeader {
    inspectionHeader: string;
    isSelected: boolean;
    isClosed: boolean;
    vehicleDefectDetail: VehicleDefectDetail[];
}
export interface VehicleDefectDetail {
    item_description: string;
    inspection_report_date: Date;
    veh_inspect_rpt_dtl_Id: number;
    defect_comment: string;
    isSelected: boolean;
    short_inspection_id: string;
    short_defect_id: string;
    safety_impact_ind: string;
}

export class SubmitResolvedDefects {
    evidenceMediaContent: string | null = null;
    evidenceMediaMimeType: string | null = null;
    evidenceRecifiedBy?: string;
    evidenceRolePosition?: string;
    supplierWorkshopName?: string;
    inspectionReportDetails: number[] | null = null;
    driverId: string = '';
    icnNo: number = 0;
    clientId: string = '';
    fileName?: string;
}